export interface InputFieldProps {
  label: string;
  placeholder?: string;
  type: string;
  disabled?: boolean;
  error?: boolean;
  value?: string;
  color?: string;
  onFocus?: React.FocusEventHandler;
  onchange: React.ChangeEventHandler;
  required?: boolean;
  usernameError?: boolean;
  metamask?: boolean;
  isEmpty?: boolean;
}

export interface Profile {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  bio: string;
  connectedWallet: string | undefined;
  skills: string[];
  genres: string[];
  profilePic: string;
}

export const INITIAL = {
  firstName: "",
  lastName: "",
  username: "",
  email: "",
  bio: "",
  connectedWallet: "",
  skills: [],
  genres: [],
  profilePic: "",
};


